import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { VirtualMedicine } from '../../../apis/virtual-medicines/types';
import { StyledPaperContainer } from '../../PlusWebsiteEditor/PlusWebsiteEditor.styles';
import { StyledButtonsContainer } from '../../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import CreateSaveVirtualMedicineButton from './Buttons/CreateSaveVirtualMedicine';
import DeleteVirtualMedicine from './Buttons/DeleteVirtualMedicine';

interface VirtualMedicineFooterProps {
  id?: string;
  form: UseFormReturn<VirtualMedicine>;
}

export const VirtualMedicineFooter = ({ form, id }: VirtualMedicineFooterProps) => {
  return (
    <StyledPaperContainer>
      <StyledButtonsContainer>
        {id && <DeleteVirtualMedicine id={id} />}
        <CreateSaveVirtualMedicineButton id={id} form={form} />
      </StyledButtonsContainer>
    </StyledPaperContainer>
  );
};
